module.exports = __webpack_public_path__ + "img/logo.c7c4a135.svg";